import { isPlatform } from '@ionic/react';
import { useState } from 'react';

import {
  Camera,
  CameraDirection,
  CameraResultType,
  CameraSource,
  Photo
} from "@capacitor/camera";

import { Directory, Filesystem } from "@capacitor/filesystem";

import imageCompression from 'browser-image-compression';
import { incluirOcorrenciaOperacao, requestService } from '../Utils/Services';

//const { Filesystem, FilesystemDirectory } = Plugins;

export function usePhotoGallery(idOperacao: string, history: any) {

  const [photos, setPhotos] = useState<UserPhoto[]>([]);

  const takePhoto = async (idOperacao: string) => {
    const cameraPhoto = await Camera.getPhoto({
      resultType: CameraResultType.Base64,
      allowEditing: false,
      direction: CameraDirection.Rear,
      source: CameraSource.Camera,
      promptLabelHeader: 'Fotos',
      promptLabelPhoto: 'Biblioteca de fotos',
      promptLabelPicture: 'Câmera',
      promptLabelCancel: 'Cancelar'
    }).then(async cameraPhoto => {

      var binary_string = window.atob(cameraPhoto.base64String || '');
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }

      const blob = new Blob([new Uint8Array(bytes.buffer)], {
        type: `image/${cameraPhoto.format}`,
      });

      const file = new File([blob], "Name", {
        lastModified: new Date().getTime(),
        type: blob.type,
      });

      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1102,
        useWebWorker: true,
        initialQuality: 0.5
      }

      const optionsSmall = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 238,
        useWebWorker: true,
        initialQuality: 0.8
      }

      try {
        const compressedFile = await imageCompression(file, options);
        console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

        let base64 = await getBase64(compressedFile);
        incluirOcorrencia(idOperacao, base64);

      } catch (error) {
        console.log(error);
      }
    })
      .catch(error => {
        console.log(error);
      });


  };

  async function getBase64(file: any) {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(file)
    })
  }

  const loadPhotos = async (_photos: string[]) => {
    let newPhotos: UserPhoto[] = [];
    _photos.forEach(path => {
      console.log(path.toString());
      newPhotos.push({ filepath: path, webviewpath: path });
    });

    setPhotos(newPhotos);
  };

  function incluirOcorrencia(operacaoId: string, base64: any) {
    const atualizar = async () => {

      requestService(incluirOcorrenciaOperacao.url, {
        method: incluirOcorrenciaOperacao.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify({
          "id": operacaoId,
          "base64": base64
        }),
        credentials: 'include'
      },
        history
        ,
        (response: any) => {
          if (response) {
            console.log(response);

            const newPhotos = [{
              filepath: response.message,
              webviewpath: response.message
            }, ...photos];
            setPhotos(newPhotos);
          }
        },
        (error: any) => {
          console.log(error);
          history.replace("/primeiroacesso")
        });
    }

    atualizar();

  };



  const savePicture = async (photo: Photo, fileName: string): Promise<UserPhoto> => {

    let base64Data: string;
    // "hybrid" will detect Cordova or Capacitor;
    if (isPlatform('hybrid')) {
      const file = await Filesystem.readFile({
        path: photo.path!
      });

      // Verificar se 'file.data' é uma string
      if (typeof file.data === 'string') {
        base64Data = file.data;
      } else {
        // Se for um Blob, converter para string
        base64Data = await new Response(file.data).text();
      }
    } else {
      base64Data = await base64FromPath(photo.webPath!);
    }
    const savedFile = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Documents
    });
    console.log("arquivo gravado");
    console.log(fileName);
    console.log(base64Data);
    console.log(Directory.Documents);
    console.log(savedFile);

    const readedfile = await Filesystem.readFile({ path: savedFile.uri });
    console.log(savedFile);

    if (isPlatform('hybrid')) {
      // Display the new image by rewriting the 'file://' path to HTTP
      // Details: https://ionicframework.com/docs/building/webview#file-protocol
      //return {
      //  filepath: savedFile.uri,
      //  webviewPath: Capacitor.convertFileSrc(savedFile.uri),
      //};
    }
    else {
      // Use webPath to display the new image instead of base64 since it's
      // already loaded into memory
      return {
        filepath: fileName,
        webviewpath: photo.webPath
      };
    }

    return {
      filepath: fileName,
      webviewpath: photo.webPath
    };
    //return {
    //  filepath: fileName,
    //  webviewPath: photo.webPath
    //     };
  };

  return {
    photos,
    takePhoto,
    loadPhotos
  };

}

export interface UserPhoto {
  filepath: string;
  webviewpath?: string;
}

export async function base64FromPath(path: string): Promise<string> {
  const response = await fetch(path);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject('method did not return a string')
      }
    };
    reader.readAsDataURL(blob);
  });
}